import { type MutableRefObject } from "react"

const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const SidebarCategoryListItem = ({
  category,
  linkRefs,
  count,
}: {
  category: string
  linkRefs: MutableRefObject<HTMLAnchorElement[]>
  count: number
}) => {
  const slug = category.toLowerCase().replace(/\s+/g, "-")

  return (
    <a
      ref={(el) => {
        if (el) {
          linkRefs.current.push(el)
        }
      }}
      href={`#${slug}`}
      key={slug}
      className="flex items-center gap-2 text-fg-secondary hover:text-fg-default hover:bg-neutral-950/5 dark:hover:bg-neutral-50/5 rounded-lg cursor-pointer p-1.5 px-2.5 -mr-1 font-medium text-sm"
    >
      {capitalizeFirstLetter(category)}
      <span className="text-fg-secondary font-normal min-w-6 mr-[-8px]">
        ({count})
      </span>
    </a>
  )
}

const SidebarCategoryList = ({
  categories,
  linkRefs,
  counts,
}: {
  categories: string[]
  linkRefs: MutableRefObject<HTMLAnchorElement[]>
  counts: number[]
}) => {
  return (
    <div className="flex flex-col items-end gap-1">
      {categories.map((category, index) => (
        <SidebarCategoryListItem
          key={category}
          category={category}
          linkRefs={linkRefs}
          count={counts[index]}
        />
      ))}
    </div>
  )
}

export default SidebarCategoryList
